import { takeLatest, put, select, call } from "redux-saga/effects";
import {
  SET_WAREHOUSE_LIST,
  ASSIGN_WAREHOUSES_BUDDY_BLOCK,
  ASSIGN_WAREHOUSES_WAREHOUSE_FENCES,
  SET_WAREHOUSE_SEARCH,
  setWarehouseList,
  setVisibleWarehouseList,
  VIEW_ASSIGNED_WAREHOUSE,
  setReplayOnAuthentication,
  setUserAuthenticated,
  setLoaderModal,
  setErrorToastMessage,
  addGeofenceWithUpdatedWarehouses
} from "../actions";

import { getWarehouses } from "../../../api/common/warehouse";

import { updateWarehousesOfGeofence } from "../../../api/geofence/city";

const FlexSearch = require("flexsearch");

export const index = new FlexSearch({
  profile: "match",
  doc: {
    id: "id",
    field: ["name", "city"]
  }
});

export function* newIndexTask(action) {
  if (index.info().items !== 0) {
    index.clear();
  }

  const docs = yield select(({ geofence }) => geofence.warehouseList);
  index.add(docs);
}

export function* watchSetWarehouses() {
  yield takeLatest(SET_WAREHOUSE_LIST, newIndexTask);
}

export function* searchAndFilterTask(action) {
  let list;
  const docs = yield select(({ geofence }) => geofence.warehouseList);
  list = docs;
  if (action.payload) {
    if (index.info().items === 0) {
      index.add(docs);
    }
    list = index.search({
      query: action.payload,
      suggest: false
    });
  }
  yield put(setVisibleWarehouseList(list));
}

export function* watchSetWarehouseSearch() {
  yield takeLatest(SET_WAREHOUSE_SEARCH, searchAndFilterTask);
}

export function* fetchWarehousesTask(action) {
  if (!action.payload) {
    return;
  }
  try {
    yield put(setLoaderModal(true));
    // TODO: Add proper pagination or server side search when warehouse list increases.
    const result = yield call(getWarehouses, 100, 1);
    const list = result.data.warehouseList;
    yield put(setVisibleWarehouseList(list));
    yield put(setWarehouseList(list));
    yield put(setLoaderModal(false));
  } catch (e) {
    console.error(e);
    if (e.response.status === 401) {
      yield put(setUserAuthenticated(false));
      yield put(setReplayOnAuthentication(action));
    }
    yield put(setLoaderModal(false));
    yield put(setErrorToastMessage(e.response.data.message));
  }
}

export function* watchViewAssignedWarehouseOf() {
  yield takeLatest(VIEW_ASSIGNED_WAREHOUSE, fetchWarehousesTask);
}

export function* assignWarehousesTask(action) {
  if (!action.payload) {
    return;
  }
  try {
    yield put(setLoaderModal(true));
    // TODO: Add proper pagination or server side search when warehouse list increases.
    const result = yield call(updateWarehousesOfGeofence, action.payload);
    const geofence = result.data.geofence;
    yield put(addGeofenceWithUpdatedWarehouses(geofence));
    yield put(setLoaderModal(false));
  } catch (e) {
    console.error(e);
    if (e.response.status === 401) {
      yield put(setUserAuthenticated(false));
      yield put(setReplayOnAuthentication(action));
    }
    yield put(setLoaderModal(false));
    yield put(setErrorToastMessage(e.response.data.message));
  }
}

export function* watchAssignWarehousesToBuddyBlock() {
  yield takeLatest(ASSIGN_WAREHOUSES_BUDDY_BLOCK, assignWarehousesTask);
}

export function* watchAssignWarehousesToWarehouseFences() {
  yield takeLatest(ASSIGN_WAREHOUSES_WAREHOUSE_FENCES, assignWarehousesTask);
}
